import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import UserService from "../../../services/UserService";
import { useUserAuth } from "../../Context/AuthUserContext";

Modal.setAppElement("#root");

const MapModal = ({ isOpen, onRequestClose, google, dishLocation }) => {
  const [center, setCenter] = useState(null);
  const [isOnline, setNetwork] = useState(window.navigator.onLine);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    setNetwork(window.navigator.onLine);
  }, []);

  const { Fbuser } = useUserAuth();

  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        if (Fbuser && Fbuser.uid) {
          const NodeUser = await UserService.getUserByUid(Fbuser.uid);
          const Address = NodeUser.address;
          // console.log("Address of the user:", Address);
          const userLocation = await UserService.getUserAddressLocation(
            Address
          );
          // Check if userLocation has finite coordinates
          if (
            userLocation &&
            typeof userLocation.latitude === "number" &&
            typeof userLocation.longitude === "number" &&
            isFinite(userLocation.latitude) &&
            isFinite(userLocation.longitude)
          ) {
            setCenter({
              lat: userLocation.latitude,
              lng: userLocation.longitude
            });
          } else {
            console.error("Invalid coordinates:", userLocation);
          }
        }
      } catch (error) {
        console.error("Error fetching user location:", error);
      }
    };

    if (isOpen) {
      fetchUserLocation();
    }
  }, [isOpen, Fbuser]);

  const mapStyles = {
    width: "100%",
    height: "100%"
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Map Modal"
      style={{
        content: {
          width: "500px",
          height: "300px"
        }
      }}
    >
      {center && isOnline ? (
        <Map
          google={google}
          zoom={14}
          style={mapStyles}
          initialCenter={center}
          center={center}
        >
          <Marker
            position={center}
            icon={{
              url: require("../../../assets/user_marker.png"),
              anchor: new window.google.maps.Point(32, 32),
              scaledSize: new window.google.maps.Size(60, 60)
            }}
          />
          {dishLocation && (
            <Marker
              position={dishLocation}
              icon={{
                url: require("../../../assets/dish_marker.png"),
                anchor: new window.google.maps.Point(32, 32),
                scaledSize: new window.google.maps.Size(60, 60)
              }}
            />
          )}
        </Map>
      ) : (
        <div>No user location available, Please add a Valid Address </div>
      )}
    </Modal>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
})(MapModal);
